
import { Component, Vue } from 'vue-property-decorator';
import Constants from '../constants';
import CommonUtils from '../common-utils'

@Component
export default class Splash extends Vue {
  swiperOption1 = {
    centeredSlides: true,
    slidesPerView: 1,
    pagination: {el: '.swiper-pagination'}
  }

  skip() {
    localStorage.setItem(Constants.NEW_CUSTOMER, "0");
    window.location.reload();
  }

  forceExitApp() {
    window['webViewBridge'].send('forceExit', {queryString: ''}, null);
  }
}

